class MaisonProduct extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
    this.querySelectorAll('[data-option]').forEach(input => input.addEventListener('change', this.handleOption));
    this.querySelectorAll('[data-gallery-button]').forEach(button => {
      button.addEventListener('mouseenter', this.handleImage);
      button.addEventListener('focus', this.handleImage);
      button.addEventListener('click', this.handleImage);
    });
  }

  handleOption = event => {
    const group = event.target.closest('[data-option-group]');
    const label = group?.querySelector('[data-option-label]');
    if (label) label.textContent = event.target.value;

    const values = [...this.querySelectorAll('[data-option-group]')].map(item =>
      item.querySelector('[data-option]:checked')?.value
    );
    const variant = this.variants.find(item => item.options.every((value, index) => value === values[index]));
    if (!variant) return;

    const record = this.querySelector(`[data-variant="${variant.id}"]`);
    const available = record?.dataset.available === 'true';
    const addButton = this.querySelector('[data-add]');
    const availability = this.querySelector('[data-availability]');

    this.querySelector('[data-variant-id]').value = variant.id;
    this.querySelector('[data-price]').textContent = record?.dataset.price || '';

    const comparePrice = this.querySelector('[data-compare]');
    comparePrice.textContent = record?.dataset.compare || '';
    comparePrice.hidden = record?.dataset.sale !== 'true';

    addButton.disabled = !available;
    this.querySelector('[data-add-text]').textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldLabel;

    if (availability) {
      availability.classList.toggle('is-available', available);
      availability.lastChild.textContent = available ? ` ${this.dataset.availableLabel}` : ` ${addButton.dataset.soldLabel}`;
    }

    if (record?.dataset.media) this.querySelector(`[data-gallery-button][data-media-id="${record.dataset.media}"]`)?.click();

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  };

  handleImage = event => {
    const button = event.currentTarget;
    const image = this.querySelector('.maison-pdp__main img');
    if (!image) return;
    image.src = button.dataset.src;
    image.srcset = button.dataset.srcset;
    image.alt = button.dataset.alt;
    this.querySelectorAll('[data-gallery-button]').forEach(item => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
  };
}

if (!customElements.get('maison-product')) customElements.define('maison-product', MaisonProduct);
